import React, { Component } from 'react'
import styled from 'styled-components'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import Text from '../Text/Text'
import { SCREEN_SIZE } from '../../lib/Media'
import Halal from '../icons/svg/halal.svg'
import HealthierChoice from '../icons/svg/healthier_choice.svg'
import Hypoallergenic from '../icons/svg/hypoallergenic.svg'
import LactoseFree from '../icons/svg/lactose_free.svg'
import TransfatFree from '../icons/svg/transfat_free.svg'
import Vegetarian from '../icons/svg/vegetarian.svg'
import Organic from '../icons/svg/organic.svg'
import GlutenFree from '../icons/svg/gluten_free.svg'
import { decodeEntities } from '../../lib/stringHelperFunctions'
import SvgInfo from '@ntuctech/devex-tangram/Icon/SvgInfo'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'

const Description = styled.div`
  background-color: white;
  overflow-wrap: break-word;
`

const Heading = styled.h2`
  letter-spacing: 0.0625rem;
  text-transform: uppercase;
  color: #0d3578;
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 1rem 1rem 0.375rem 1rem;
  }
  ${SCREEN_SIZE.From.Tablet} {
    margin-bottom: 0.5rem;
  }
`

const DescriptionList = styled.ul`
  list-style-type: none;
  padding: 0;
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 0 1rem;
    > li:not(:last-child) {
      margin-bottom: ${props => (props.listWithGap ? '1.25rem' : '0rem')};
    }
  }
`

const DescriptionListItem = styled.li`
  color: #333333;
`
const PlainCard = styled.div`
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 0 1rem;
  }
`

const Nutrition = styled.ul`
  border: 1px solid ${defaultTheme.ColorBaseMineShaft80};
  border-radius: 4px;
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 0.5rem 1rem 0;
  }
`

const Item = styled.li`
  display: flex;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: ${defaultTheme.ColorBaseMineShaft700};
  border-top: 1px solid ${defaultTheme.ColorBaseMineShaft80};
  &:nth-child(even) {
    background-color: ${defaultTheme.ColorBaseMineShaft50};
  }
  &:first-child {
    font-weight: bold;
    border-top: none;
  }
`

const ColRight = styled.div`
  margin-left: auto;
`

const DieatryContainer = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  > div {
    margin-right: 0.75rem;
  }
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 0 1rem;
  }
`

const DieatryElements = styled.div`
  display: inline-flex;
  align-items: center;
  padding-bottom: 4px;
  > span {
    margin-left: 0.375rem;
  }
`

const BlockText = styled(Text)`
  display: block;
`

const InfoIconContainer = styled.button`
  margin: 0;
  margin-left: 0.25rem;
  display: flex;
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
`

const DieartryIconMapper = {
  vegetarian: Vegetarian,
  hypoallergenic: Hypoallergenic,
  lactosefree: LactoseFree,
  glutenfree: GlutenFree,
  healthierchoice: HealthierChoice,
  organic: Organic,
  halal: Halal,
  transfatfree: TransfatFree,
}

const MapKeyToTitle = {
  'Country of Origin': 'Country/place of Origin',
  description: 'Additional Information',
  'Storage Information': 'Storage',
  Ingredients: 'Ingredients',
  'Nutritional Data': 'Nutrition Info',
  Preparation: 'Preparation',
  'Dietary Attributes': 'Dietary',
  'Key Information': 'Key Information',
}

const StyledIcon = styled.img`
  height: 1.5rem;
  width: 1.5rem;
`

class ProductDescription extends Component {
  render() {
    let { title, data } = this.props
    const nutritions = []
    if (title === 'Dietary Attributes') {
      data = Array.isArray(data) && data.length && data.join('<br/>')
    }
    if (title === 'Nutritional Data') {
      const rows = data.split(/<tr>|<\/tr>|<table {2}border='1'>|<\/table>/)
      rows.forEach(row => {
        if (row) {
          const temp = row.split(/<th>|<\/th>|<td>|<\/td>/)
          const col1 = temp[1]
          const col2 = temp[3]
          if (col1 && col2) {
            const redundantTags = /<[^>]*>|<\/[^>]*>/g
            nutritions.push([
              col1.replace(redundantTags, ''),
              col2.replace(redundantTags, ''),
            ])
          }
        }
      })
    }
    try {
      data = decodeEntities(data).split(/<\s*br\s*\/?>/) // change split logic according to delimeter once it is fixed in API
    } catch (error) {
      // do nothing
    }

    data = data && data.filter(Boolean)
    let type = data.length === 1 ? 'PlainCard' : 'List' // Extedn this logic to support table view after API start supports for that
    if (title === 'Nutritional Data') {
      type = 'table'
    }
    if (title === 'Dietary Attributes') {
      type = 'Dieatry'
    }
    const { isEnabled: healthierChoiceInfoEnabled } = getConfigFor(
      SPLIT_FEATURES.HEALTHIER_CHOICE_INFO_ENABLED
    )
    if (data) {
      return (
        <Description>
          {Boolean(title) && (
            <Heading title={title}>
              <Text
                size="small"
                weight="black"
                color={defaultTheme.ColorBaseMineShaft500}
              >
                {MapKeyToTitle[title]}
              </Text>
            </Heading>
          )}
          {type === 'Dieatry' && (
            <DieatryContainer>
              {data.map(key => {
                const caseInsensitiveKey = (key || '')
                  .toLowerCase()
                  .replace(/[^a-z]+/g, '')
                const iconSrc = DieartryIconMapper[caseInsensitiveKey]
                const text = key.replace(/<\s*\/?u\s*>/g, '')
                return (
                  <DieatryElements key={key}>
                    {iconSrc && (
                      <StyledIcon src={iconSrc} alt="Dietary information" />
                    )}
                    <Text
                      size="medium"
                      color={defaultTheme.ColorBaseMineShaft700}
                      weight="bold"
                    >
                      {decodeEntities(text)}
                    </Text>
                    {healthierChoiceInfoEnabled &&
                      caseInsensitiveKey === 'healthierchoice' && (
                        <InfoIconContainer
                          data-testid="healthier-choice-info"
                          onClick={() => {
                            this.props.onHealthierChoiceInfoPress()
                          }}
                        >
                          <SvgInfo size="s" color="#666666" />
                        </InfoIconContainer>
                      )}
                  </DieatryElements>
                )
              })}
            </DieatryContainer>
          )}
          {type === 'List' && (
            <DescriptionList
              listWithGap={MapKeyToTitle[title] === 'Additional Information'}
            >
              {data.map(element => {
                const text = element.replace(/<[^>br]*>|<\/[^>br]*>/g, '')
                return text ? (
                  <DescriptionListItem key={element}>
                    <Text
                      size="medium"
                      weight="regular"
                      color={defaultTheme.ColorBaseMineShaft700}
                    >
                      {decodeEntities(text)}
                    </Text>
                  </DescriptionListItem>
                ) : null
              })}
            </DescriptionList>
          )}
          {type === 'PlainCard' &&
            data.map(element => {
              const plainCardValue = decodeEntities(element).replace(
                /<[^>br]*>|<\/[^>br]*>/g,
                ''
              )
              const lineBrokenValues = plainCardValue.split(/<\s*br\s*\/?>/)
              return (
                <PlainCard key={element}>
                  {lineBrokenValues.map(
                    plainValue =>
                      plainValue && (
                        <BlockText
                          size="medium"
                          weight="regular"
                          key={plainValue}
                          color={defaultTheme.ColorBaseMineShaft700}
                        >
                          {plainValue}
                        </BlockText>
                      )
                  )}
                </PlainCard>
              )
            })}
          {nutritions.length > 0 && type === 'table' && (
            <Nutrition>
              {nutritions.map((value, index) => {
                return (
                  <Item key={index}>
                    <div>{decodeEntities(value[0])}</div>
                    <ColRight>{decodeEntities(value[1])}</ColRight>
                  </Item>
                )
              })}
            </Nutrition>
          )}
        </Description>
      )
    } else {
      return null
    }
  }
}

export default ProductDescription
